import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { buildWaLink } from '@/config/brand';
import { useContent } from '@/lib/content';
import { trackEvent } from '@/lib/analytics';

export const WhatsAppFloat = () => {
  const { brand } = useContent();
  return (
  <motion.a
    data-testid="whatsapp-float"
    href={buildWaLink(brand.whatsapp)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Events by AJ on WhatsApp"
    onClick={() => trackEvent('whatsapp_click', { location: 'floating_button' })}
    initial={{ opacity: 0, scale: 0.5 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 group"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" />
    <span className="relative w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center text-white shadow-lg shadow-black/40 group-hover:scale-110 transition-transform duration-300">
      <FaWhatsapp size={26} />
    </span>
  </motion.a>
  );
};
